import { useQuery } from "@tanstack/react-query";
import type { AdminListingChangeListDTO, ListingChangeStatus } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/listing-changes?status=pending|approved|declined
//
// 0091 marketplace listing-change review queue. The response carries
// `configured: false` when MARKETPLACE_* secrets are unset — the queue
// (Colab data) still lists, but listing names are unresolved and the page
// shows the approvals-blocked banner.
export function useListingChanges(status: ListingChangeStatus) {
  return useQuery<AdminListingChangeListDTO, ApiClientError>({
    queryKey: queryKeys.admin.listingChanges.list(status),
    queryFn: () =>
      apiFetch<AdminListingChangeListDTO>(
        `/admin/listing-changes?status=${status}`,
      ),
  });
}
